export const legalLabels = {
  ro: {
    eyebrow: "Informații legale",
    updated: "Ultima actualizare: 28 septembrie 2026",
    terms: "Termeni și Conditii",
    privacy: "Politica de Confidențialitate (GDPR)",
    cookies: "Politica de Cookies",
  },
  en: {
    eyebrow: "Legal information",
    updated: "Last updated: September 28, 2026",
    terms: "Terms & Conditions",
    privacy: "Privacy Policy (GDPR)",
    cookies: "Cookie Policy",
  },
};

export const legalDocs = {
  terms: {
    ro: {
      title: "Termeni și Conditii",
      intro: "Vă rugăm să citiți acești termeni cu atenție. Utilizarea site-ului www.emanteam.eu implică acceptarea prevederilor de mai jos.",
      sections: [
        {
          h: "1. Informații generale",
          ps: [
            "Acest site este deținut și operat de EMAN TEAM Dynamics S.R.L., cu sediul social în Bd. Pipera nr. I-VIII, et. 3, Voluntari, Ilfov, CP 077190, România, denumită în continuare „EMAN TEAM”.",
            "Date de înregistrare: CUI 51309516 • Număr de înmatriculare în Registrul Comerțului: J23/11514/2025 • Data înregistrării: 18 februarie 2025.",
            "Pentru orice întrebări legate de acești termeni, ne puteți contacta la adresa de email: office@emanteam.eu.",
          ],
        },
        {
          h: "2. Obiectul site-ului",
          ps: [
            "Site-ul are caracter de prezentare a serviciilor și soluțiilor oferite de EMAN TEAM și a tehnologiilor furnizate împreună cu partenerii săi de tehnologie (IBM, KonectSystems, 3eeco).",
            "Informațiile afișate au caracter informativ și general și nu constituie o ofertă contractuală, garanție sau consultanță specifică. O relație contractuală se naște exclusiv prin documente separate, semnate cu clienții.",
          ],
        },
        {
          h: "3. Utilizarea site-ului",
          ps: [
            "Vă angajați să utilizați site-ul în mod legal și licit, fără a-i afecta disponibilitatea, integritatea sau securitatea și fără a încerca acces neautorizat la sistemele aferente.",
            "Este interzisă utilizarea site-ului în scopuri frauduloase, transmiterea de conținut malițios sau colectarea automată abuzivă de date.",
          ],
        },
        {
          h: "4. Proprietate intelectuală",
          ps: [
            "Conținutul site-ului (texte, structură, elemente grafice, marca EMAN TEAM) aparține EMAN TEAM Dynamics S.R.L. și nu poate fi reprodus sau folosit comercial fără acordul scris al companiei.",
            "IBM, watsonx, KonectSystems, KRONOS, 3eeco, ATLAS și alte denumiri menționate sunt mărci ale deținătorilor lor respectivi; utilizarea lor pe acest site are exclusiv caracter descriptiv, în contextul prezentării parteneriatelor tehnologice.",
          ],
        },
        {
          h: "5. Limitarea răspunderii",
          ps: [
            "Site-ul este pus la dispoziție „în starea în care se află”. Depunem eforturi rezonabile pentru acuratețea informațiilor, dar nu garantăm că acestea sunt complete sau actualizate în permanență.",
            "EMAN TEAM nu răspunde pentru decizii luate exclusiv pe baza informațiilor publicate pe site și nu răspunde pentru întreruperi temporare cauzate de mentenanță sau factori externi.",
          ],
        },
        {
          h: "6. Linkuri către site-uri terțe",
          ps: [
            "Site-ul conține linkuri către site-urile partenerilor și ale autorităților (de exemplu ibm.com, konectsystems.com, 3eeco.com, anpc.ro). Nu controlăm conținutul acestora și nu răspundem pentru politicile sau practicile lor.",
          ],
        },
        {
          h: "7. Legea aplicabilă și litigii",
          ps: [
            "Acești termeni sunt guvernați de legea română. Eventualele litigii se soluționează mai întâi pe cale amiabilă; în lipsa unui acord, sunt competente instanțele judecătorești din România.",
            "Consumatorii pot apela la ANPC (https://anpc.ro) sau la procedura de soluționare alternativă a litigiilor (SAL).",
          ],
        },
        {
          h: "8. Dispoziții finale",
          ps: [
            "EMAN TEAM poate actualiza acești termeni oricând; versiunea publicată pe site la momentul utilizării este cea aplicabilă.",
            "Ultima actualizare: 28 septembrie 2026.",
          ],
        },
      ],
    },
    en: {
      title: "Terms & Conditions",
      intro: "Please read these terms carefully. Using www.emanteam.eu implies acceptance of the provisions below.",
      sections: [
        {
          h: "1. General information",
          ps: [
            "This website is owned and operated by EMAN TEAM Dynamics S.R.L., with registered office at Bd. Pipera nr. I-VIII, et. 3, Voluntari, Ilfov, CP 077190, Romania (hereinafter “EMAN TEAM”).",
            "Registration details: Tax ID (CUI) 51309516 • Trade Registry Number J23/11514/2025 • Date of registration: 18 February 2025.",
            "For any questions regarding these terms, contact us at: office@emanteam.eu.",
          ],
        },
        {
          h: "2. Purpose of the website",
          ps: [
            "The website presents the services and solutions offered by EMAN TEAM and the technologies provided together with its technology partners (IBM, KonectSystems, 3eeco).",
            "The information displayed is general and informational in nature and does not constitute a contractual offer, warranty or specific advice. A contractual relationship arises exclusively through separate documents signed with clients.",
          ],
        },
        {
          h: "3. Use of the website",
          ps: [
            "You agree to use the website lawfully, without affecting its availability, integrity or security and without attempting unauthorized access to related systems.",
            "Fraudulent use, transmission of malicious content and abusive automated data collection are prohibited.",
          ],
        },
        {
          h: "4. Intellectual property",
          ps: [
            "The website content (texts, structure, graphic elements, the EMAN TEAM mark) belongs to EMAN TEAM Dynamics S.R.L. and may not be reproduced or used commercially without the company's written consent.",
            "IBM, watsonx, KonectSystems, KRONOS, 3eeco, ATLAS and other names mentioned are trademarks of their respective owners; their use on this website is purely descriptive, in the context of presenting technology partnerships.",
          ],
        },
        {
          h: "5. Limitation of liability",
          ps: [
            "The website is provided “as is”. We make reasonable efforts to keep information accurate, but we do not guarantee that it is complete or permanently up to date.",
            "EMAN TEAM is not liable for decisions made solely on the basis of information published on the website, nor for temporary interruptions caused by maintenance or external factors.",
          ],
        },
        {
          h: "6. Third-party links",
          ps: [
            "The website contains links to partner and authority websites (e.g. ibm.com, konectsystems.com, 3eeco.com, anpc.ro). We do not control their content and are not responsible for their policies or practices.",
          ],
        },
        {
          h: "7. Governing law and disputes",
          ps: [
            "These terms are governed by Romanian law. Disputes are settled amicably first; failing agreement, the competent courts of Romania have jurisdiction.",
            "Consumers may contact ANPC (https://anpc.ro) or use the alternative dispute resolution (ADR) procedure.",
          ],
        },
        {
          h: "8. Final provisions",
          ps: [
            "EMAN TEAM may update these terms at any time; the version published on the website at the time of use is the applicable one.",
            "Last updated: September 28, 2026.",
          ],
        },
      ],
    },
  },

  privacy: {
    ro: {
      title: "Politica de Confidențialitate (GDPR)",
      intro: "Această politică descrie cum EMAN TEAM Dynamics S.R.L. colectează și procesează datele cu caracter personal prin site-ul www.emanteam.eu, în conformitate cu Regulamentul (UE) 2016/679 (GDPR).",
      sections: [
        {
          h: "1. Operatorul de date",
          ps: [
            "Operator este EMAN TEAM Dynamics S.R.L., Bd. Pipera nr. I-VIII, et. 3, Voluntari, Ilfov, CP 077190. Pentru orice problematici de confidențialitate: office@emanteam.eu.",
          ],
        },
        {
          h: "2. Ce date colectăm",
          ps: [
            "Date furnizate de dumneavoastră prin formularul „Solicită o Soluție”: nume, companie, email de serviciu, telefon (opțional), domeniul de interes și conținutul mesajului.",
            "Date stocate local în browserul dumneavoastră (localStorage): preferința de limbă și confirmarea notificării de informare privind stocarea esențială. Nu folosim cookie-uri de analiză sau marketing.",
          ],
        },
        {
          h: "3. Scopul și temeiul procesării",
          ps: [
            "Răspunsul la solicitările trimise prin formular — art. 6 alin. (1) lit. (b) GDPR (măsuri precontractuale la cererea dumneavoastră).",
            "Menținerea securității și funcționării site-ului, precum și comunicări ulterioare în legătură cu solicitarea dumneavoastră — art. 6 alin. (1) lit. (f) GDPR (interes legitim).",
          ],
        },
        {
          h: "4. Nu vindem și nu publicăm datele",
          ps: [
            "Nu vindem, nu închiriem și nu facem publice datele dumneavoastră și nu le folosim pentru campanii de marketing adresate unor liste de destinatari.",
          ],
        },
        {
          h: "5. Cui divulgăm datele",
          ps: [
            "Angajaților implicați în răspunsul la solicitarea dumneavoastră.",
            "Furnizorilor de infrastructură necesari funcționării site-ului: platforma de găzduire a aplicației și serviciul gestionat de trimitere a emailurilor, care procesează datele ca persoane împuternicite, pe baza instrucțiunilor noastre.",
          ],
        },
        {
          h: "6. Stocarea și securitatea",
          ps: [
            "Solicitările sunt salvate în baza de date a site-ului și transmise la adresa office@emanteam.eu. Aplicăm măsuri tehnice și organizatorice rezonabile, inclusiv limitarea accesului la date.",
          ],
        },
        {
          h: "7. Durata păstrării",
          ps: [
            "Păstrăm datele din formulare pentru perioada necesară gestionării solicitării, iar ulterior conform obligațiilor legale aplicabile; le ștergem la solicitare, dacă nu există o obligație legală de păstrare.",
          ],
        },
        {
          h: "8. Drepturile dumneavoastră",
          ps: [
            "Aveți dreptul de acces, rectificare, ștergere, restricționare a procesării, portabilitate a datelor, opoziție și dreptul de a depune plângere la Autoritatea Națională de Supraveghere a Prelucrării Datelor cu Caracter Personal (ANSPDCP, https://www.anspdcp.ro).",
            "Pentru exercitarea drepturilor, scrieți-ne la office@emanteam.eu.",
          ],
        },
        {
          h: "9. Transferuri internaționale",
          ps: [
            "Anumiți furnizori de infrastructură pot procesa date în afara Spațiului Economic European; în astfel de cazuri asigurăm măsuri adecvate de protecție (clauze contractuale standard sau echivalente).",
          ],
        },
        {
          h: "10. Modificări ale politicii",
          ps: [
            "Politica poate fi actualizată oricând; versiunea publicată pe site este cea aplicabilă. Ultima actualizare: 28 septembrie 2026.",
          ],
        },
      ],
    },
    en: {
      title: "Privacy Policy (GDPR)",
      intro: "This policy describes how EMAN TEAM Dynamics S.R.L. collects and processes personal data through www.emanteam.eu, in accordance with Regulation (EU) 2016/679 (GDPR).",
      sections: [
        {
          h: "1. Data controller",
          ps: [
            "The controller is EMAN TEAM Dynamics S.R.L., Bd. Pipera nr. I-VIII, et. 3, Voluntari, Ilfov, CP 077190, Romania. For privacy matters: office@emanteam.eu.",
          ],
        },
        {
          h: "2. What data we collect",
          ps: [
            "Data you provide through the “Request a Solution” form: name, company, work email, phone (optional), area of interest and message content.",
            "Data stored locally in your browser (localStorage): your language preference and the confirmation of the essential-storage notice. We use no analytics or marketing cookies.",
          ],
        },
        {
          h: "3. Purpose and legal basis",
          ps: [
            "Responding to requests submitted through the form — art. 6(1)(b) GDPR (pre-contractual measures at your request).",
            "Maintaining the security and operation of the website, as well as follow-up communication related to your request — art. 6(1)(f) GDPR (legitimate interest).",
          ],
        },
        {
          h: "4. We do not sell or publish your data",
          ps: [
            "We do not sell, rent or make public your data, and we do not use it for marketing campaigns aimed at recipient lists.",
          ],
        },
        {
          h: "5. Who we disclose data to",
          ps: [
            "Employees involved in answering your request.",
            "Infrastructure providers necessary for the website to operate: the application hosting platform and the managed email delivery service, which process data as processors, on our instructions.",
          ],
        },
        {
          h: "6. Storage and security",
          ps: [
            "Requests are stored in the website database and delivered to office@emanteam.eu. We apply reasonable technical and organizational measures, including restricted access to data.",
          ],
        },
        {
          h: "7. Retention period",
          ps: [
            "We keep form data for the period necessary to handle the request and, thereafter, in line with applicable legal obligations; we delete it upon request, unless a legal retention obligation exists.",
          ],
        },
        {
          h: "8. Your rights",
          ps: [
            "You have the right of access, rectification, erasure, restriction of processing, data portability, objection and the right to lodge a complaint with the Romanian National Supervisory Authority for Personal Data Processing (ANSPDCP, https://www.anspdcp.ro).",
            "To exercise your rights, write to office@emanteam.eu.",
          ],
        },
        {
          h: "9. International transfers",
          ps: [
            "Some infrastructure providers may process data outside the European Economic Area; in such cases we ensure adequate protection measures (standard contractual clauses or equivalent safeguards).",
          ],
        },
        {
          h: "10. Changes to this policy",
          ps: [
            "This policy may be updated at any time; the version published on the website is the applicable one. Last updated: September 28, 2026.",
          ],
        },
      ],
    },
  },

  cookies: {
    ro: {
      title: "Politica de Cookies",
      intro: "Această politică explică modul în care site-ul www.emanteam.eu folosește stocarea locală în browser (cookie-uri și localStorage).",
      sections: [
        {
          h: "1. Ce folosim",
          ps: [
            "Site-ul folosește exclusiv stocare esențială, necesară funcționării: preferința de limbă (RO/EN) și confirmarea dumneavoastră a notificării de informare. Acestea sunt stocate local, în browserul dumneavoastră (localStorage), și nu sunt transmise către servicii de analiză.",
          ],
        },
        {
          h: "2. Ce NU folosim",
          ps: [
            "Nu folosim cookie-uri de statistică/analytics, cookie-uri de marketing sau publicitate și nici module sociale de la terți. Prin urmare, nu există și nu este necesar un mecanism de consimțământ granular pe categorii de cookie-uri.",
          ],
        },
        {
          h: "3. Cum controlați stocarea",
          ps: [
            "Puteți șterge oricând datele stocate local din setările browserului („Clear site data” / „Șterge datele site-ului”) sau le puteți bloca complet; site-ul va reafișeza notificarea de informare, dar va funcționa în continuare.",
          ],
        },
        {
          h: "4. Actualizări",
          ps: [
            "Dacă în viitor introducem instrumente care necesită consimțământ (de exemplu statistici), vom actualiza această politică și vom cere consimțământul înainte de activare. Ultima actualizare: 28 septembrie 2026.",
          ],
        },
      ],
    },
    en: {
      title: "Cookie Policy",
      intro: "This policy explains how www.emanteam.eu uses local browser storage (cookies and localStorage).",
      sections: [
        {
          h: "1. What we use",
          ps: [
            "The website uses only essential storage required for operation: your language preference (RO/EN) and your confirmation of the information notice. These are stored locally in your browser (localStorage) and are not sent to analytics services.",
          ],
        },
        {
          h: "2. What we do NOT use",
          ps: [
            "We use no statistics/analytics cookies, no marketing or advertising cookies and no third-party social modules. Consequently, there is — and there needs to be — no granular per-category cookie consent mechanism.",
          ],
        },
        {
          h: "3. How you control storage",
          ps: [
            "You can delete locally stored data at any time from your browser settings (“Clear site data”) or block it completely; the website will show the information notice again but will keep working.",
          ],
        },
        {
          h: "4. Updates",
          ps: [
            "If we ever introduce tools that require consent (e.g. statistics), we will update this policy and ask for consent before activating them. Last updated: September 28, 2026.",
          ],
        },
      ],
    },
  },
};
